import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export const getOrgInvestors = async () => fetcher.get({
  path: '/investors/organization/',
});

export const createInvestor = async (data) => fetcher.post({
  path: '/investors',
  body: data,
});

export const updateInvestor = async (investorId, recordType, data) => fetcher.put({
  path: `/investors/${investorId}/${recordType}`,
  body: data,
});

export const deleteInvestor = async (investorId, recordType) => fetcher.delete({
  path: `/investors/${recordType}`,
  body: {
    id: investorId,
  },
});
